// extracted by mini-css-extract-plugin
export default {"sectionTitle":"pY1Nnp8FuI","sectionSeparator":"Mc1dptpX3f"};